<script>
export default {
  name: "ActionButton",
  props: ['iconType', 'disabled'],
  emits: ['buttonClick']
}
</script>

<template>
  <button
      @click.stop.prevent="$emit('buttonClick')"
      class="actionButton"
      :disabled="disabled"
  >
    <slot name="caption">Кнопка</slot>
    <slot name="icon">
        <template v-if="iconType === 'arrow'">
            <div class="actionButton__arrow">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.25 9.49786H14.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.5 4.24786L14.75 9.49786L9.5 14.7479" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
        </template>
    </slot>
  </button>
</template>

<style lang="scss" scoped>


.actionButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition: colors 0.3s; // Можно указать другую продолжительность или свойства
  border: none;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    ring: 1px solid var(--ring-color, #d1d5db); // Убедитесь, что переменная `--ring-color` определена
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  &__arrow {
    background-color: #62C064;
    border-radius: 100px;
    width: 41px;
    height: 41px;
    min-width: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  svg {
    pointer-events: none;
    size: 4px; // Корректная реализация для размера
    flex-shrink: 0;
  }

  padding: 0.5rem; // px-4 py-2
  height: 50px;
  gap: 10px;
  border-radius: 100px;
  background-color: var(--cd-button-bg-color);
  color: var(--cd-text);
  font-weight: var(--cd-default-font-weight);
  font-size: var(--cd-text-m-font-size);
  font-style: normal;

  &:hover {
    background-color: var(--cd-button-bg-color);
    color: var(--cd-highlight-text);
  }
}
</style>
